import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiSvgModule } from "@taiga-ui/core";
import { KwikUIToasterComponent } from "./toaster.component";
import { KwikUIToasterService } from "./toaster.service";

@NgModule({
  declarations: [KwikUIToasterComponent],
  imports: [CommonModule, TuiSvgModule],
  exports: [KwikUIToasterComponent],
  providers: [KwikUIToasterService]
})
export class KwikUIToasterModule {}
